<template>
  <div class="details_form_item">
    <Form ref="editModel" :model="editModel" :label-width="100" >
       <FormItem label="用户名称" >
          <span> {{editModel.userName}}</span>
      </FormItem>
       <FormItem label="医院名称" >
          <span> {{editModel.hospitalName}}</span>
      </FormItem>
       <FormItem label="秘钥" >
          <span> {{editModel.secret}}</span>
      </FormItem>
       <FormItem label="服务名称" >
          <span> {{editModel.serverName}}</span>
      </FormItem>
       <FormItem label="hospitalId" >
          <span> {{editModel.hospitalId}}</span>
      </FormItem>
       <FormItem label="accessId" >
          <span> {{editModel.accessId}}</span>
      </FormItem>
       <FormItem label="achiveApi" >
          <span> {{editModel.achiveApi}}</span>
      </FormItem>
       <FormItem label="dImageUrl" >
          <span> {{editModel.dImageUrl}}</span>
      </FormItem>
       <FormItem label="deleteFlag" >
          <span> {{editModel.deleteFlag}}</span>
      </FormItem>
       <FormItem label="eUnityAddress" >
          <span> {{editModel.eUnityAddress}}</span>
      </FormItem>
       <FormItem label="eUnityUser" >
          <span> {{editModel.eUnityUser}}</span>
      </FormItem>
       <FormItem label="maxDays" >
          <span> {{editModel.maxDays}}</span>
      </FormItem>
       <FormItem label="privateKey" >
          <span> {{editModel.privateKey}}</span>
      </FormItem>
       <FormItem label="productCode" >
          <span> {{editModel.productCode}}</span>
      </FormItem>
       <FormItem label="providerId" >
          <span> {{editModel.providerId}}</span>
      </FormItem>
       <FormItem label="publicKey" >
          <span> {{editModel.publicKey}}</span>
      </FormItem>
       <FormItem label="rasType" >
          <span> {{editModel.rasType}}</span>
      </FormItem>
       <FormItem label="createDate" >
          <span> {{editModel.createDate}}</span>
      </FormItem>
    </Form>
    <div class="ml-5 mt-5 text-center modal-foter">
      <Button @click="returnBack">关 闭</Button>
    </div>
  </div>
</template>
<script>
export default {
  props: ["editModelTemp"],
  components: {},
  data: function () {
    return {
      editModel: {},
    };
  },

  created: function () {
    this.editModel = this.editModelTemp;
  },

  methods: {
    returnBack: function () {
      this.$emit("close");
    },
  },
};
</script>
<style scoped>
.wrodbreak{
  word-break: break-all;
}
</style>